import { SVGProps, Ref, forwardRef } from 'react';

export const SquaresIntersectedOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.346 11.167h-.013C.667 11.167 0 10.5 0 5.833S.667.5 5.333.5c4.31 0 5.208.568 5.32 4.33h.013c4.667 0 5.334.667 5.334 5.333s-.667 5.334-5.334 5.334c-4.309 0-5.207-.569-5.32-4.33M1.4 5.833c0-1.156.043-1.96.153-2.543.107-.568.253-.782.354-.883s.315-.247.883-.354c.582-.11 1.387-.153 2.543-.153s1.962.043 2.543.153c.568.107.783.253.884.354s.247.315.354.883c.076.403.12.912.14 1.57-3.283.162-3.883 1.092-3.92 4.907-1.157 0-1.962-.044-2.544-.153-.568-.107-.782-.253-.883-.354s-.247-.316-.354-.884C1.443 7.795 1.4 6.99 1.4 5.833m9.265.397h.001c1.156 0 1.962.043 2.543.153.568.107.783.253.884.354s.247.316.354.884c.11.581.153 1.386.153 2.542s-.044 1.962-.153 2.543c-.107.568-.253.783-.354.884s-.316.247-.884.354c-.581.11-1.387.153-2.543.153s-1.96-.043-2.543-.153c-.568-.107-.782-.253-.883-.354s-.247-.316-.354-.884c-.076-.402-.12-.91-.14-1.569 3.283-.162 3.883-1.092 3.919-4.907m-1.4.03c-.01.932-.056 1.61-.151 2.116-.107.568-.253.783-.354.884s-.316.247-.884.354c-.31.058-.684.098-1.14.122.01-.931.054-1.608.15-2.115.107-.568.253-.783.354-.884s.315-.247.883-.354c.31-.059.685-.098 1.141-.122"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
SquaresIntersectedOutlinedSize16Glyph.displayName = 'SquaresIntersectedOutlinedSize16Glyph';
